<div class="footer">
  <div class="version-tag"><span>{{ environment.evnName }}</span><small
    class="font-weight-bold">{{ environment.version }}</small></div>
  <div class="copyright">
    <p>
      Copyright © Developed by
      <a href="https://www.ideabilisim.com/" target="_blank"
      >İDEA BİLİŞİM VE DANIŞMANLIK</a
      >
      All Rights Reserved {{ environment.version }}
    </p>
  </div>
</div>
